import React from "react";
import {
  Show,
  TopToolbar,
  SimpleShowLayout,
  TextField,
  DateField,
  RichTextField,
  EditButton,
  FunctionField,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { TenantRender } from "./TenantField";
import { ClipboardTextField } from "../../../components/common/CopyToClipboardButton";

const LogShowActions = ({ basePath, data }) => {
  return (
    <TopToolbar>
      <BackButton basePath={basePath} />
      <EditButton basePath={basePath} record={data} />
    </TopToolbar>
  );
};

export const LogShow = (props) => {
  return (
    <Show {...props} title="Log View" actions={<LogShowActions />}>
      <SimpleShowLayout>
        <DateField source="createdAt" label="Created At" showTime={true} />
        <TextField source="appType" />
        <FunctionField source="tenantId" label="Tenant" render={TenantRender} />
        <ClipboardTextField {...props} source="tenantId" label="Tenant ID" />
        <ClipboardTextField {...props} source="user" />
        <ClipboardTextField {...props} source="message" label="Path" />
        <ClipboardTextField {...props} source="url" label="URL" />
        <RichTextField
          source="exception"
          style={{ width: "100px", maxWidth: "100px" }}
        />
        <TextField source="appVersion" />
        <TextField source="context" />
      </SimpleShowLayout>
    </Show>
  );
};
